import React, { useState } from "react";
import LiveLotsStatus from "./LiveLotsStatus";
import ServiceLiveLotInfo from "../children/ServiceLiveLotInfo";
import ServiceLiveBididngArea from "../children/ServiceLiveBididngArea";
import ReverseLiveBididngHistory from "../table/ReverseLiveBididngHistory";

function ServiceLiveLotDetails({ liveOfferData, singleAuctionData, index }) {
  const [veiwBidDetails, setVeiwBidDetails] = useState(false);
  const [bidderDetails, setBidderDetails] = useState([]);
  return (
    <>
      <div
        className="liveLots pin-top"
        style={{
          border: "1px solid black",
          borderRadius: "12px 0px 12px 12px",
        }}
      >
        <div>{index}</div>
        <div
          style={{
            backgroundColor: "#fcf1ff",
            borderRadius: "12px 0px 12px 12px",
          }}
        >
          <ServiceLiveLotInfo liveOfferData={liveOfferData} />
          <hr className="black" style={{ height: "0.5px" }} />
          <ServiceLiveBididngArea
            liveOfferData={liveOfferData}
            veiwBidDetails={veiwBidDetails}
            setVeiwBidDetails={setVeiwBidDetails}
            setBidderDetails={setBidderDetails}
            singleAuctionData={singleAuctionData}
          />
        </div>
        <LiveLotsStatus
          singleAuctionData={singleAuctionData}
          item={liveOfferData}
        />
      </div>
      {veiwBidDetails && (
        <ReverseLiveBididngHistory bidderDetails={bidderDetails} />
      )}
    </>
  );
}

export default ServiceLiveLotDetails;
